import type { LeadershipPoint } from '@portfolio/shared';
import type { JSX } from 'react';

interface LeadershipPanelProps {
  points: readonly LeadershipPoint[];
  headingLevel?: 'h3' | 'h4';
}

export function LeadershipPanel({
  points,
  headingLevel: Heading = 'h3',
}: LeadershipPanelProps): JSX.Element {
  return (
    <ul className="grid gap-px overflow-hidden rounded-lg border border-line bg-line sm:grid-cols-2">
      {points.map((point) => (
        <li key={point.id} className="bg-surface p-6">
          <Heading className="text-base">{point.title}</Heading>
          <p className="mt-2 text-sm text-muted">{point.description}</p>
        </li>
      ))}
    </ul>
  );
}
